module.exports = __webpack_public_path__ + "img/hero_s@2x.c079f4e5.webp";